import { BridgeComponent } from '@hotwired/hotwire-native-bridge';

// Bridge component for opening URLs in a native modal sheet.
// On native: sends the URL to iOS/Android which presents a native sheet.
// On web: this controller is not used (Bootstrap modal handles it).
//
// Usage:
//   <div data-controller="bridge--modal"
//        data-bridge--modal-url-value="https://external-page.com"
//        data-bridge--modal-title-value="Payment"
//        data-bridge--modal-redirect-url-value="/redirect-after">
export default class extends BridgeComponent {
  static component = 'modal';
  static values = {
    url: String,
    title: { type: String, default: '' },
    redirectUrl: { type: String, default: '' },
  };

  connect() {
    super.connect();
    this.send(
      'display',
      { url: this.urlValue, title: this.titleValue },
      ({ data }) => {
        this.handleDismiss(data);
      },
    );
  }

  handleDismiss(data) {
    this.element.remove();

    // Trigger callback in background (for payment status check)
    if (data.callbackUrl) {
      const url = new URL(data.callbackUrl, window.location.origin);
      url.searchParams.delete('signed_context');
      fetch(url.toString(), { credentials: 'same-origin' });
    }

    // Navigate to redirect page, bypassing Turbo to avoid
    // interference with the form submission lifecycle
    if (this.redirectUrlValue) {
      window.location.href = this.redirectUrlValue;
    }
  }
}
